import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed grid grid-rows-5 grid-cols-5 grid-flow-col items-stretch h-screen w-screen z-50 justify-items-center bg-black bg-opacity-50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "text-6xl material-icons text-white mr-2" }, "cancel", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "row-start-2 col-start-2 col-span-3 row-span-3 justify-center items-center font-mono"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-stretch md:items-center"
}
const _hoisted_6 = { class: "my-4 text-2xl text-white" }
const _hoisted_7 = { class: "my-4 text-xl text-white" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col items-stretch md:items-center"
}
const _hoisted_9 = { class: "my-4 text-2xl text-white" }
const _hoisted_10 = { class: "my-4 text-xl text-white" }
const _hoisted_11 = { class: "sr-only" }
const _hoisted_12 = {
  key: 0,
  class: "text-base text-red-400 font-bold ml-2"
}
const _hoisted_13 = {
  key: 1,
  class: "shrink-0 py-2"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex flex-row items-left m-4" }
const _hoisted_16 = { class: "text-xl text-white mr-2" }
const _hoisted_17 = {
  type: "text",
  ref: "nameRef",
  maxlength: "128",
  minlength: "1",
  class: "text-sm my-2 text-slate-500 rounded-sm border-1 text-sm bg-white file:text-gray-800 hover:bg-gray-100"
}
const _hoisted_18 = {
  key: 0,
  class: "text-base text-red-400 font-bold ml-2"
}
const _hoisted_19 = { class: "flex flex-row items-left m-4" }
const _hoisted_20 = { class: "text-xl text-white mr-2" }
const _hoisted_21 = {
  type: "text",
  ref: "descRef",
  maxlength: "512",
  minlength: "1",
  class: "text-sm my-2 text-slate-500 rounded-sm border-1 text-sm bg-white file:text-gray-800 hover:bg-gray-100"
}
const _hoisted_22 = {
  key: 0,
  class: "text-base text-red-400 font-bold ml-2"
}
const _hoisted_23 = {
  key: 3,
  type: "button",
  class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow",
  disabled: ""
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "animate-spin material-icons text-lg text-op-teal mr-2" }, "schedule", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.nftRequestPhoto?.photoId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "col-start-4 row-span-1 col-span-1 flex justify-center items-center",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_3),
        (_ctx.isShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.errorAlready)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("message.NFTuploadTitle")), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("message.NFTAlreadyRequested")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("message.NFTuploadTitle")), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("message.NFTuploadDetail")), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("message.selectImage")), 1),
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInput",
                      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                      class: "text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-1 file:text-sm file:font-semibold file:bg-white file:text-gray-800 hover:file:bg-gray-100"
                    }, null, 544),
                    (_ctx.fileError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("message.nftFileError")), 1))
                      : _createCommentVNode("", true),
                    (_ctx.previewImage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("img", {
                            ref: "imageRef",
                            class: "h-40 object-cover rounded-md",
                            src: _ctx.previewImage,
                            alt: "selected photo"
                          }, null, 8, _hoisted_14)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("label.name")) + ": ", 1),
                      _createElementVNode("input", _hoisted_17, null, 512),
                      (_ctx.nameError)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("message.nameError")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("label.description")) + ": ", 1),
                      _createElementVNode("input", _hoisted_21, null, 512),
                      (_ctx.descError)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("message.descError")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.processing)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nftRequest && _ctx.nftRequest(...args))),
                          class: "bg-green-800 hover:bg-green-100 text-white md:w-2/3 justify-center font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                        }, _toDisplayString(_ctx.$t("function.requestNFT")), 1))
                      : (_openBlock(), _createElementBlock("button", _hoisted_23, [
                          _hoisted_24,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("message.processing")), 1)
                        ]))
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}